type Props = {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
};

export default function Pagination({ page, totalPages, onChange }: Props) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  const start = Math.max(1, page - 2);
  const end = Math.min(totalPages, start + 4);
  for (let i = start; i <= end; i += 1) pages.push(i);

  const btnBase =
    "min-w-[36px] h-9 px-3 rounded-md text-sm flex items-center justify-center transition-colors cursor-pointer whitespace-nowrap";

  return (
    <nav className="flex items-center justify-center gap-2 flex-wrap" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={page <= 1}
        className={`${btnBase} border border-background-300 text-foreground-700 hover:bg-background-100 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        <i className="ri-arrow-left-s-line" aria-hidden="true"></i>
        <span className="hidden sm:inline">上一页</span>
      </button>
      {start > 1 && (
        <>
          <button type="button" onClick={() => onChange(1)} className={`${btnBase} border border-background-300 text-foreground-700 hover:bg-background-100`}>
            1
          </button>
          {start > 2 && <span className="text-foreground-400 px-1">…</span>}
        </>
      )}
      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`${btnBase} ${
            p === page
              ? "bg-primary-600 text-background-50"
              : "border border-background-300 text-foreground-700 hover:bg-background-100"
          }`}
        >
          {p}
        </button>
      ))}
      {end < totalPages && (
        <>
          {end < totalPages - 1 && <span className="text-foreground-400 px-1">…</span>}
          <button
            type="button"
            onClick={() => onChange(totalPages)}
            className={`${btnBase} border border-background-300 text-foreground-700 hover:bg-background-100`}
          >
            {totalPages}
          </button>
        </>
      )}
      <button
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={page >= totalPages}
        className={`${btnBase} border border-background-300 text-foreground-700 hover:bg-background-100 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        <span className="hidden sm:inline">下一页</span>
        <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
      </button>
    </nav>
  );
}